import { initializeApp } from 'firebase/app'
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

// Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBY4BsIdW0ljOgb-vz-Wq2jnNfwxyRW7xo',
  authDomain: 'maestro-connect-2e3f0.firebaseapp.com',
  projectId: 'maestro-connect-2e3f0',
  storageBucket: 'maestro-connect-2e3f0.firebasestorage.app',
  messagingSenderId: '126157978509',
  appId: '1:126157978509:web:1a4145c92da89aa225dbc4',
}

// FIXED: Use a more reliable approach for actionCodeSettings
// Using an explicit URL format rather than relying on window.location.origin
// which can sometimes cause issues with Firebase Auth
export const actionCodeSettings = {
  // Make sure this matches exactly with your deployed URL structure
  url:
    typeof window !== 'undefined'
      ? `${window.location.protocol}//${window.location.host}/verify-email`
      : 'https://maestro-connect-2e3f0.web.app/verify-email',
  // This must be true for email verification
  handleCodeInApp: true,
  // Adding iOS and Android settings for completeness
  // These are optional but help with mobile verification flows
  iOS: {
    bundleId: 'com.maestroconnect.app',
  },
  android: {
    packageName: 'com.maestroconnect.app',
    installApp: true,
    minimumVersion: '12',
  },
  // Adding dynamic link domain if you have one
  // dynamicLinkDomain: "maestroconnect.page.link"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Get Firebase services
export const auth = getAuth(app)

// CRITICAL FIX: Set persistence to LOCAL for mobile reliability
// This ensures auth state persists across sessions using localStorage (more reliable on iOS)
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('[Auth] Persistence set to browserLocalPersistence')
  })
  .catch((error) => {
    console.error('[Auth] Failed to set persistence:', error)
    // Continue anyway - auth will still work, just may not persist
  })

export const db = getFirestore(app)
export const storage = getStorage(app)

export default app
